import React from "react";

export default function EasterFrame4({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".clse4-1{fill:#1b1b36}.clse4-2{fill:#dd572e}.clse4-3{fill:#f6be64}"
            }
          </style>
        </defs>
        <path
          className="clse4-1"
          d="M1749.16 1026.54c30.29 43.49.21 105.37-3.13 112-9.16-4.41-43-22-55-59.9-9.62-30.52-4.45-72.72 14.17-79 14.64-4.89 34.47 13.28 43.96 26.9ZM1687 1174.55c44 14 56.13 72.75 57.35 79.11-8.68 1.82-41.45 7.62-69.83-12.22-22.87-16-41.72-47.92-32.18-62.14 7.53-11.15 30.9-9.13 44.66-4.75Z"
        />
        <path
          className="clse4-2"
          d="M1713.23 1214.11c19.75 6.27 25.17 32.62 25.71 35.46-3.89.82-18.58 3.42-31.3-5.47-10.25-7.17-18.7-21.48-14.42-27.86 3.35-5 13.83-4.09 20.01-2.13Z"
        />
        <path
          className="clse4-1"
          d="M1827.49 1134.16c-46.47 1.15-73.08 56-75.87 61.94 8 4.31 38.48 19.54 71.15 8.05 26.34-9.27 52.78-35.51 47.06-52.38-4.48-13.23-27.78-17.97-42.34-17.61Z"
        />
        <path
          className="clse4-2"
          d="M1789.54 1167.67c-19.49.48-30.65 23.48-31.82 26 3.36 1.8 16.14 8.19 29.84 3.37 11-3.88 22.13-14.89 19.74-22-1.88-5.53-11.65-7.52-17.76-7.37Z"
        />
        <path
          className="clse4-1"
          d="M1815.54 1283.59c-44.63-13-86.63 31.16-91.09 36 6.31 6.54 30.74 30.3 65.36 29.26 27.91-.83 61.06-17.81 60.73-35.63-.26-13.97-21.02-25.56-35-29.63Z"
        />
        <path
          className="clse4-2"
          d="M1779.11 1299.37c-22.42-6.54-43.52 15.65-45.76 18.08 3.17 3.28 15.44 15.22 32.83 14.69 14-.41 30.67-8.94 30.51-17.89-.13-7.02-10.56-12.84-17.58-14.88Z"
        />
        <path
          className="clse4-1"
          d="M1686.4 1390.48a3.58 3.58 0 0 1-2.65-6c.21-.23 21.91-24.51 39.69-68.45 16.39-40.52 32.71-106.54 17.39-191a3.57 3.57 0 0 1 7-1.27c15.66 86.31-1.1 153.83-17.92 195.27-18.27 45-40 69.25-40.89 70.26a3.58 3.58 0 0 1-2.62 1.19Z"
        />
        <path
          className="clse4-2"
          d="M1745.23 1081.49c14.23 20.43.1 49.49-1.47 52.6-4.3-2.06-20.2-10.34-25.81-28.13-4.52-14.34-2.09-34.16 6.65-37.1 6.86-2.31 16.18 6.23 20.63 12.63Z"
        />
        <path
          className="clse4-1"
          d="M363.09 1817.32c-38.63-6.41-55.84-54.25-57.62-59.43 7-2.57 33.84-11.39 60 1.83 21.11 10.66 40.77 35.16 34.47 48.25-4.94 10.25-24.74 11.36-36.85 9.35ZM316.85 1708.1c-30.12 16.1-67.45-7.83-71.43-10.47 3.51-5.53 17.35-25.86 42.48-30.63 20.26-3.85 46.87 2.65 49.47 15 2.04 9.74-11.09 21.06-20.52 26.1Z"
        />
        <path
          className="clse4-2"
          d="M282.41 1701.55c-13.51 7.22-30.24-3.51-32-4.69 1.57-2.48 7.77-11.59 19-13.73 9.08-1.73 21 1.18 22.18 6.74.93 4.35-4.95 9.42-9.18 11.68Z"
        />
        <path
          className="clse4-1"
          d="M265.76 1803.24c23.37-25.17 8.09-67.54 6.37-72.09-6.4 2-30.19 10.28-41 33.49-8.69 18.71-8.45 46.23 3.43 51.91 9.35 4.45 23.87-5.42 31.2-13.31Z"
        />
        <path
          className="clse4-2"
          d="M267.61 1765.88c9.8-10.56 3.39-28.33 2.67-30.23-2.68.84-12.66 4.31-17.18 14-3.64 7.85-3.54 19.39 1.44 21.77 3.91 1.91 10-2.23 13.07-5.54Z"
        />
        <path
          className="clse4-1"
          d="M192.88 1719.83c29.91-16.9 28.2-61.9 28-66.75-6.71 0-31.89.63-49.2 19.47-13.95 15.2-22.07 41.49-12.48 50.51 7.47 7.07 24.31 2.07 33.68-3.23Z"
        />
        <path
          className="clse4-2"
          d="M203.33 1692.42c15-8.49 14.16-31.1 14-33.53-3.37 0-16 .31-24.71 9.78-7 7.63-11.09 20.84-6.27 25.37 3.81 3.55 12.27 1.04 16.98-1.62Z"
        />
        <path
          className="clse4-1"
          d="M313.81 1767.86a3.53 3.53 0 0 1-2-.61c-53.92-36.37-81.09-80.23-94.38-110.62-14.46-33-16.09-57.18-16.15-58.19a3.58 3.58 0 0 1 7.14-.45c0 .24 1.66 24.14 15.69 56.08 12.93 29.43 39.33 71.93 91.7 107.26a3.57 3.57 0 0 1-2 6.53Z"
        />
        <path
          className="clse4-2"
          d="M336.06 1786.9c-18.15-3-26.24-25.48-27.07-27.92 3.31-1.21 15.89-5.35 28.19.86 9.92 5 19.15 16.52 16.2 22.66-2.32 4.82-11.64 5.34-17.32 4.4Z"
        />
        <path
          className="clse4-1"
          d="M1005.1 255c-44.5-28.64-105.08 3.74-111.56 7.32 4.74 9 23.58 42.16 61.78 52.67 30.79 8.47 72.68 1.73 78.23-17.12C1037.9 283.1 1019 264 1005.1 255ZM859.83 322.61c-15.58-43.5-74.63-53.38-81-54.35-1.49 8.73-6.06 41.7 14.78 69.32 16.81 22.26 49.34 39.9 63.17 29.83 10.83-7.9 7.94-31.18 3.05-44.8Z"
        />
        <path
          className="clse4-2"
          d="M819.41 297.91c-7-19.5-33.46-23.93-36.32-24.36-.67 3.91-2.71 18.69 6.63 31.07 7.53 10 22.12 17.89 28.32 13.37 4.85-3.54 3.56-13.99 1.37-20.08Z"
        />
        <path
          className="clse4-1"
          d="M894.87 180.74c.59 46.48-53.1 75.13-58.93 78.14-4.6-7.83-20.92-37.73-10.68-70.81 8.25-26.66 33.43-54.06 50.47-49 13.35 4 18.95 27.1 19.14 41.67Z"
        />
        <path
          className="clse4-2"
          d="M862.87 219.92c.25 19.49-22.27 31.5-24.71 32.76-1.93-3.28-8.78-15.82-4.48-29.69 3.46-11.18 14-22.67 21.16-20.54 5.6 1.67 7.95 11.36 8.03 17.47Z"
        />
        <path
          className="clse4-1"
          d="M746.32 198.27c14.68 44.12-27.85 87.73-32.49 92.38-6.75-6.06-31.36-29.59-31.62-64.22-.21-27.92 15.49-61.68 33.26-62 13.93-.29 26.26 20.02 30.85 33.84Z"
        />
        <path
          className="clse4-2"
          d="M732 235.27c7.35 22.16-14 44.07-16.32 46.4-3.4-3-15.76-14.86-15.89-32.25-.1-14 7.78-31 16.71-31.16 6.95-.13 13.14 10.07 15.5 17.01Z"
        />
        <path
          className="clse4-1"
          d="M648.12 334.77a3.58 3.58 0 0 1-2.5-6.13c1-.95 24.33-23.56 68.53-43.5 40.7-18.36 107.4-37.63 194.06-25.21a3.57 3.57 0 1 1-1 7.07c-84.79-12.15-150 6.63-189.79 24.52-43.15 19.41-66.55 42-66.78 42.23a3.58 3.58 0 0 1-2.52 1.02Z"
        />
        <path
          className="clse4-2"
          d="M950.46 261c-20.91-13.45-49.36 1.76-52.4 3.44 2.22 4.22 11.07 19.8 29 24.74 14.47 4 34.14.81 36.75-8 2.05-7-6.81-16-13.35-20.18Z"
        />
        <path
          className="clse4-1"
          d="M1593.22 246.26c36.39 12.69 45.08 62 45.94 67.3-7.27 1.31-34.73 5.38-57.92-11.83-18.69-13.87-33.65-40.93-25.36-52.56 6.5-9.12 25.94-6.88 37.34-2.91ZM1619.78 359.94c31.91-10.56 64.1 18.9 67.53 22.12-4.33 4.77-21.16 22.17-46.33 22.6-20.3.34-45-10.42-45.47-22.87-.35-9.79 14.28-18.54 24.27-21.85Z"
        />
        <path
          className="clse4-2"
          d="M1652.09 372.06c14.3-4.73 28.73 8.47 30.27 9.92-1.94 2.14-9.48 9.94-20.77 10.13-9.1.15-20.18-4.67-20.38-10.26-.16-4.37 6.4-8.3 10.88-9.79Z"
        />
        <path
          className="clse4-1"
          d="M1685.27 276.22c-26.89 20.51-19.16 64.16-18.26 68.85 6.55-.87 31-4.91 45.34-25.61 11.56-16.7 15.93-43.43 5.36-50.93-8.28-5.88-24.02 1.27-32.44 7.69Z"
        />
        <path
          className="clse4-2"
          d="M1677.21 312.15c-11.27 8.6-8 26.91-7.65 28.87 2.74-.36 13-2.06 19-10.74 4.85-7 6.68-18.21 2.25-21.35-3.46-2.47-10.06.53-13.6 3.22Z"
        />
        <path
          className="clse4-1"
          d="M1742 369.32c-31.83 11.39-37.72 55.32-38.29 60.07 6.51 1.16 31 4.73 51-10.65 16.08-12.4 28.36-36.55 20.57-46.9-6.15-8.11-23.28-6.08-33.28-2.52Z"
        />
        <path
          className="clse4-2"
          d="M1727.26 394.16c-16 5.72-19 27.79-19.23 30.18 3.26.58 15.58 2.37 25.6-5.36 8.08-6.22 14.25-18.35 10.33-23.55-3.07-4.08-11.69-3.06-16.7-1.27Z"
        />
        <path
          className="clse4-1"
          d="M1710 488.85h-.39a3.57 3.57 0 0 1-3.16-3.94c0-.34 2.4-23.77-5.84-57-7.6-30.7-26.09-76.33-71-119.35a3.58 3.58 0 1 1 4.95-5.16c46.22 44.32 65.23 91.42 73 123.13 8.48 34.47 6 58.17 5.91 59.17a3.58 3.58 0 0 1-3.47 3.15Z"
        />
        <path
          className="clse4-2"
          d="M1614.35 280.3c17.09 6 21.17 29.11 21.58 31.61-3.42.62-16.32 2.53-27.21-5.56-8.78-6.51-15.8-19.22-11.91-24.69 3.05-4.28 12.19-3.23 17.54-1.36Z"
        />
        <path
          className="clse4-1"
          d="M1656.78 767.62c-5.19 27.86 20.13 55.63 22.89 58.58 3.24-3.81 15-18.61 13.06-40.53-1.56-17.67-12-39.1-21.49-39.38-7.46-.22-12.83 12.59-14.46 21.33ZM1712.93 835.62c-17 14.53-11.12 47.51-10.44 51.06 4.22-.45 20-2.71 28.85-17.79 7.15-12.15 9.45-32.06 2.46-38-5.49-4.68-15.54.18-20.87 4.73Z"
        />
        <path
          className="clse4-2"
          d="M1708.82 860.75c-7.62 6.52-5 21.3-4.68 22.89 1.89-.2 8.95-1.22 12.93-8 3.21-5.45 4.24-14.38 1.1-17-2.46-2.11-6.96.07-9.35 2.11Z"
        />
        <path
          className="clse4-1"
          d="M1642.43 837.13c21-7 43.4 17.66 45.78 20.35-2.74 3.58-13.44 16.57-30.24 15.81-13.55-.61-30.4-10.16-31.08-20-.53-7.7 8.96-13.99 15.54-16.16Z"
        />
        <path
          className="clse4-2"
          d="M1665.82 848.64c8.8-2.91 18.19 7.41 19.19 8.54-1.15 1.5-5.63 7-12.68 6.63-5.68-.26-12.74-4.26-13-8.39-.25-3.23 3.73-5.86 6.49-6.78Z"
        />
        <path
          className="clse4-1"
          d="M1676.44 914c17.44-14.12 44.68 2.37 47.6 4.2-1.56 4.47-7.92 21-23.59 26-12.63 4.1-30.69.52-34-8.93-2.53-7.33 4.55-16.82 9.99-21.27Z"
        />
        <path
          className="clse4-2"
          d="M1695.74 916.44c8.77-7.09 22.45 1.19 23.92 2.1-.79 2.25-4 10.54-11.85 13.09-6.35 2.06-15.42.26-17.07-4.48-1.28-3.73 2.26-8.49 5-10.71Z"
        />
        <path
          className="clse4-1"
          d="M1754 951.14a3.54 3.54 0 0 1-1.92-.56c-.61-.39-15.17-9.78-32.11-30.75-15.56-19.24-36.12-52.33-45.73-100.66a3.57 3.57 0 1 1 7-1.4c17.83 89.65 74.1 126.42 74.67 126.78a3.58 3.58 0 0 1-1.92 6.59Z"
        />
        <path
          className="clse4-2"
          d="M1669.08 796c-2.44 13.09 9.45 26.13 10.75 27.52a26.11 26.11 0 0 0 6.13-19c-.73-8.3-5.62-18.36-10.09-18.49-3.5-.18-6.03 5.84-6.79 9.97Z"
        />
        <path
          className="clse4-1"
          d="M179.5 1369.47c-11.86 25.74 5.88 58.86 7.84 62.4 4.08-2.9 19.09-14.37 22.59-36.09 2.82-17.52-2-40.84-11.18-43.44-7.18-2.04-15.53 9.06-19.25 17.13ZM217.28 1449.16c-20 9.92-22.42 43.33-22.64 46.94 4.21.6 20 2.27 32.34-10.18 9.91-10 17-28.77 11.69-36.26-4.17-5.86-15.11-3.61-21.39-.5Z"
        />
        <path
          className="clse4-2"
          d="M207.14 1472.51c-9 4.45-10.06 19.43-10.15 21 1.88.27 9 1 14.49-4.57 4.45-4.49 7.63-12.89 5.24-16.25-1.87-2.58-6.72-1.57-9.58-.18Z"
        />
        <path
          className="clse4-1"
          d="M148.56 1433.34c22-1.59 37.74 27.76 39.4 31-3.54 2.8-17.1 12.77-33.2 7.92-13-3.91-27-17.3-25.23-27 1.37-7.65 12.12-11.42 19.03-11.92Z"
        />
        <path
          className="clse4-2"
          d="M168.41 1450.24c9.24-.67 15.83 11.64 16.52 13-1.48 1.17-7.17 5.35-13.92 3.32-5.44-1.64-11.31-7.26-10.58-11.33.57-3.23 5.08-4.78 7.98-4.99Z"
        />
        <path
          className="clse4-1"
          d="M162.69 1516.23c20.37-9.41 42.74 13.25 45.12 15.73-2.61 4-12.82 18.4-29.25 19.49-13.25.87-29.89-7-30.75-17-.67-7.8 8.49-15.27 14.88-18.22Z"
        />
        <path
          className="clse4-2"
          d="M180.81 1523.3c10.24-4.73 21.48 6.65 22.67 7.9-1.31 2-6.44 9.24-14.69 9.79-6.66.44-15-3.53-15.45-8.54-.34-3.92 4.27-7.67 7.47-9.15Z"
        />
        <path
          className="clse4-1"
          d="M229.63 1571.32a3.55 3.55 0 0 1-2.6-1.13c-.5-.52-12.31-13.2-23.6-37.67-10.36-22.47-22.19-59.59-19.67-108.81a3.57 3.57 0 0 1 7.14.37c-4.68 91.28 40.87 140.72 41.33 141.21a3.58 3.58 0 0 1-2.6 6Z"
        />
        <path
          className="clse4-2"
          d="M184.48 1400c-5.57 12.09 2.76 27.65 3.68 29.31a26.11 26.11 0 0 0 10.61-17c1.32-8.23-1-19.18-5.25-20.41-3.37-.9-7.3 4.28-9.04 8.1Z"
        />
        <path
          className="clse4-1"
          d="M681.41 1788.87c30.13 18.2 73.45.9 78.09-1-3-5.43-15.09-25.55-41.4-32.88-21.22-5.9-50.67-3.17-55.15 7.78-3.52 8.55 9.05 20.4 18.46 26.1ZM785 1753.3c9.47 26.11 50.36 33.68 54.78 34.44 1.32-5.1 5.57-24.41-8.07-41.3-11-13.62-33.14-25-43.12-19.46-7.85 4.34-6.59 18.15-3.59 26.32Z"
        />
        <path
          className="clse4-2"
          d="M812.38 1769.06c4.25 11.7 22.58 15.1 24.56 15.44.59-2.29 2.5-10.94-3.62-18.52-4.93-6.1-14.86-11.2-19.33-8.72-3.5 1.94-2.94 8.13-1.61 11.8Z"
        />
        <path
          className="clse4-1"
          d="M755.93 1835.9c1.09-27.42 39.49-42.72 43.65-44.32 3 4.75 13.38 22.86 5.16 42.06-6.62 15.48-25.08 30.88-36.8 27.38-9.19-2.74-12.35-16.53-12.01-25.12Z"
        />
        <path
          className="clse4-2"
          d="M779.53 1813.75c.46-11.5 16.56-17.91 18.3-18.58 1.24 2 5.61 9.58 2.17 17.63-2.78 6.49-10.52 13-15.44 11.49-3.85-1.15-5.17-6.93-5.03-10.54Z"
        />
        <path
          className="clse4-1"
          d="M860.16 1830c-8.79-26.44 22.27-50.9 25.66-53.49 4.52 3.77 20.93 18.37 20 38.79-.76 16.47-12.81 35.91-25.22 35.58-9.74-.3-17.69-12.63-20.44-20.88Z"
        />
        <path
          className="clse4-2"
          d="M871.39 1808.58c-4.41-13.29 11.19-25.57 12.89-26.88 2.27 1.9 10.51 9.23 10 19.49-.38 8.27-6.43 18-12.67 17.87-4.85-.13-8.84-6.32-10.22-10.48Z"
        />
        <path
          className="clse4-1"
          d="M799.81 1794.5a312.81 312.81 0 0 1-50.74-4.22 3.57 3.57 0 1 1 1.17-7c58.59 9.64 104.56.55 132.81-8.78 30.63-10.11 47.63-22.68 47.8-22.8a3.58 3.58 0 0 1 4.29 5.72c-.72.53-17.88 13.27-49.51 23.76a273.08 273.08 0 0 1-85.82 13.32Z"
        />
        <path
          className="clse4-2"
          d="M719.74 1787c14.15 8.55 34.5.42 36.67-.48A32.38 32.38 0 0 0 737 1771c-10-2.78-23.8-1.49-25.91 3.65-1.68 4.07 4.21 9.63 8.65 12.35Z"
        />
        <path
          className="clse4-1"
          d="M1128.4 253.27c19.8 20.28 57.08 15.57 61.08 15-1.25-4.85-6.59-23-25.62-34-15.34-8.9-38.86-12.73-44.57-5.1-4.47 5.97 2.91 17.74 9.11 24.1ZM1216.34 246.5c2.09 22.27 32.44 36.45 35.73 37.94 2.06-3.71 9.29-17.9 2.07-33.83-5.83-12.85-20.78-26.19-29.68-23.9-6.97 1.8-8.78 12.82-8.12 19.79Z"
        />
        <path
          className="clse4-2"
          d="M1234.52 264.34c.94 10 14.54 16.33 16 17 .93-1.66 4.17-8 .93-15.17-2.61-5.75-9.31-11.73-13.3-10.71-3.15.81-3.93 5.75-3.63 8.88Z"
        />
        <path
          className="clse4-1"
          d="M1177 305c6.4-21.16 39.43-25.31 43-25.72 1.34 4.3 5.8 20.53-4.49 33.83-8.3 10.73-25.8 19-34.24 13.9-6.63-4.01-6.27-15.36-4.27-22.01Z"
        />
        <path
          className="clse4-2"
          d="M1199.86 292.53c2.68-8.88 16.53-10.62 18-10.79.56 1.81 2.43 8.61-1.88 14.19-3.48 4.5-10.82 8-14.36 5.83-2.74-1.68-2.62-6.45-1.76-9.23Z"
        />
        <path
          className="clse4-1"
          d="M1259.44 321.49c-1.5-22.4 27.66-35.18 30.83-36.51 2.76 3.85 12.6 18.55 7.73 34.28-3.92 12.69-17.25 25.4-26.86 22.64-7.54-2.17-11.24-13.4-11.7-20.41Z"
        />
        <path
          className="clse4-2"
          d="M1272.52 307.09c-.75-11.25 13.9-17.67 15.49-18.34 1.38 1.93 6.32 9.32 3.88 17.22-2 6.37-8.67 12.76-13.49 11.37-3.79-1.09-5.65-6.73-5.88-10.25Z"
        />
        <path
          className="clse4-1"
          d="M1276 289.7c-24.36 0-57.73-4.3-95.42-21a3.58 3.58 0 0 1 2.9-6.54c83.56 37 146 12.19 146.65 11.94a3.57 3.57 0 0 1 2.72 6.61c-.68.28-16.74 6.77-43.63 8.56-4.04.26-8.46.43-13.22.43Z"
        />
        <path
          className="clse4-2"
          d="M1158.67 259.54c9.3 9.52 26.81 7.31 28.69 7a26.14 26.14 0 0 0-12-16c-7.21-4.18-18.25-6-20.93-2.4-2.14 2.86 1.32 8.41 4.24 11.4Z"
        />
        <path
          className="clse4-1"
          d="M208 397.57c4.42-29.14 39-49.56 42.78-51.71a56.23 56.23 0 0 1-1 43.93c-7.6 17.11-25.27 35.45-34.8 33-7.42-1.85-8.35-16.09-6.98-25.22ZM287 345.9c-11.85-19.23 5.29-50.32 7.18-53.65 4 1.64 18.86 8.33 22.48 25.81 2.91 14.09-1.65 34.51-10.62 38.45-7.04 3.08-15.34-4.59-19.04-10.61Z"
        />
        <path
          className="clse4-2"
          d="M291.54 319.78c-5.31-8.62 2.37-22.55 3.22-24 1.81.74 8.46 3.74 10.08 11.57 1.3 6.32-.74 15.47-4.76 17.24-3.16 1.33-6.87-2.11-8.54-4.81Z"
        />
        <path
          className="clse4-1"
          d="M217.66 324.5c18.41 12.82 49.06-5.29 52.35-7.29-1.5-4.32-7.64-20.24-24.54-24.24-13.63-3.22-33.6 1.51-37.65 11.08-3.17 7.5 4.08 16.43 9.84 20.45Z"
        />
        <path
          className="clse4-2"
          d="M244.78 319.66c7.72 5.38 20.58-2.21 22-3.05-.62-1.81-3.2-8.49-10.29-10.17-5.71-1.35-14.08.64-15.78 4.65-1.38 3.15 1.66 6.91 4.07 8.57Z"
        />
        <path
          className="clse4-1"
          d="M277.75 257.74c12.44 18.94 45.09 10.26 48.6 9.27 0-4.88-.64-23.07-14.42-32.53-11.1-7.63-30.23-9.18-36.72-.72-5.08 6.63-1.35 18.04 2.54 23.98Z"
        />
        <path
          className="clse4-2"
          d="M297.71 260.8c6.24 9.51 22.64 5.15 24.41 4.66 0-2.46-.33-11.59-7.25-16.35-5.57-3.83-15.18-4.61-18.44-.36-2.55 3.33-.68 9.07 1.28 12.05Z"
        />
        <path
          className="clse4-1"
          d="M246.2 356.56a3.61 3.61 0 0 1-1.78-.48 3.57 3.57 0 0 1-1.31-4.88c26.07-45.2 57.74-72.2 79.72-86.9 23.92-16 41.5-21.19 42.24-21.41a3.58 3.58 0 0 1 2 6.87c-.87.25-69.39 21.15-117.76 105a3.56 3.56 0 0 1-3.11 1.8Z"
        />
        <path
          className="clse4-2"
          d="M229.93 372.89C232 359.2 248.27 349.61 250 348.6a26.41 26.41 0 0 1-.46 20.63c-3.57 8-11.87 16.65-16.35 15.52-3.47-.89-3.91-7.58-3.26-11.86Z"
        />
        <path
          className="clse4-3"
          d="M1729.24 1542.73c40.25 34 98.71 114 62 174.65-22.29 36.84-73.4 56.2-115.13 45.54-84.11-21.5-84.07-153.26-84-159.48.28-20.31 1-78.22 36.22-95.26 38.15-18.46 89.04 24.52 100.91 34.55Z"
        />
        <path
          className="clse4-1"
          d="M1751.12 1610c9.34 14.71-1.4 34.62-2.59 36.75-3-1.57-13.83-7.83-17.22-20.44-2.74-10.16-.45-24 5.75-25.75 4.86-1.45 11.13 4.8 14.06 9.44ZM1728.65 1657.73c14.28 5.2 17.43 24.68 17.74 26.78-2.88.48-13.73 1.93-22.77-5-7.29-5.57-13-16.33-9.71-20.87 2.61-3.53 10.26-2.54 14.74-.91ZM1775.35 1646.41c-15.28-.27-24.79 17.38-25.79 19.29 2.57 1.53 12.38 7 23.27 3.64 8.78-2.68 17.83-10.93 16.19-16.56-1.29-4.4-8.88-6.29-13.67-6.37ZM1769.35 1695.33c-14.48-4.89-28.9 9-30.43 10.56 2 2.24 9.68 10.38 21.07 10.52 9.18.12 20.3-5 20.44-10.86.11-4.55-6.54-8.68-11.08-10.22Z"
        />
        <path
          className="clse4-1"
          d="M1725.48 1728.67a1.16 1.16 0 0 1-.83-.34 1.19 1.19 0 0 1 0-1.69c.29-.3 29.74-30.92 22.35-84.43a1.19 1.19 0 0 1 1-1.34 1.18 1.18 0 0 1 1.34 1c7.56 54.73-22.71 86.13-23 86.44a1.2 1.2 0 0 1-.86.36ZM1638.6 1534.78c-9.67 7.44-7.36 23.11-7.09 24.8 2.32-.33 11-1.85 16.22-9.33 4.23-6 6-15.65 2.38-18.32-2.86-2.09-8.48.52-11.51 2.85ZM1642 1571.58c-10.64 0-17.38 12.07-18.08 13.38 1.77 1 8.56 4.55 16.17 2.17 6.13-1.92 12.49-7.62 11.38-11.41-.91-2.96-6.18-4.14-9.47-4.14ZM1613.94 1553c10.12 3.48 12.15 17.37 12.35 18.87-2.06.39-9.81 1.61-16.18-3.18-5.14-3.86-9.12-11.46-6.69-14.76 1.9-2.63 7.34-2.06 10.52-.93ZM1606.18 1586.59c10.7.24 16.85 12.86 17.49 14.22-1.84 1-8.85 4.52-16.37 1.89-6.07-2.12-12.17-8.15-10.86-12 1.03-3.09 6.39-4.19 9.74-4.11Z"
        />
        <path
          className="clse4-1"
          d="M1627.35 1619.42a1.18 1.18 0 0 1-1.08-.69c-.13-.28-12.61-28.34 5.54-62.69a1.19 1.19 0 0 1 2.11 1.11c-17.58 33.27-5.61 60.32-5.49 60.59a1.19 1.19 0 0 1-.58 1.58 1.27 1.27 0 0 1-.5.1ZM1644.06 1744a3.57 3.57 0 0 1-3.08-1.75c-8.68-14.54-11.09-27.22-7.14-37.7 4.37-11.57 14.62-15.88 24.53-20 9-3.76 17.41-7.31 21.63-16 4.55-9.36 1-18.06-3-28.14-4.16-10.34-8.87-22.06-3.23-34.95 5.19-11.87 15.72-17 25-21.49 8.89-4.31 16.57-8 19.2-16.58 2.87-9.29-1.16-21-12-34.95a3.57 3.57 0 1 1 5.64-4.39c12.32 15.85 16.75 29.79 13.16 41.45s-13.4 16.29-22.92 20.91c-9 4.35-17.45 8.46-21.58 17.91-4.44 10.15-.67 19.51 3.32 29.42 4.29 10.69 8.74 21.73 2.8 33.93-5.4 11.1-16 15.54-25.29 19.45s-17.33 7.28-20.61 16c-3.14 8.34-.92 18.94 6.59 31.52a3.58 3.58 0 0 1-1.23 4.9 3.62 3.62 0 0 1-1.79.46Z"
        />
        <path
          className="clse4-3"
          d="M1790.07 609.29c.1 28.16-12.21 79.63-49.59 85.7-22.71 3.68-48.28-10.41-58.39-31.08-20.37-41.67 33.26-87.27 35.82-89.39 8.36-6.92 32.19-26.65 51.3-18.23 20.71 9.12 20.79 44.71 20.86 53Z"
        />
        <path
          className="clse4-1"
          d="M1770.29 641.47c-2.75 8.9-14.57 11.42-15.85 11.67-.38-1.74-1.6-8.34 2.35-14.08 3.19-4.64 9.59-8.48 12.47-6.58 2.26 1.52 1.89 6.2 1.03 8.99ZM1743.07 648.86c2.83 7.61-4 15.64-4.75 16.49-1.19-1-5.54-4.91-5.86-11-.26-4.89 2.13-11 5.13-11.17 2.35-.18 4.6 3.3 5.48 5.68ZM1763.85 664c-5.18-6.31-15.66-4.07-16.78-3.82.27 1.58 1.45 7.45 6.57 10.73 4.13 2.65 10.62 3.47 12.34.86 1.35-2.1-.51-5.84-2.13-7.77ZM1741.86 678.44c-3-7.59-13.68-8.63-14.83-8.72-.22 1.58-.87 7.53 3 12.21 3.13 3.78 9.07 6.53 11.5 4.56 1.92-1.49 1.28-5.67.33-8.05Z"
        />
        <path
          className="clse4-1"
          d="M1714.92 673h-1.41a1.19 1.19 0 0 1-1.1-1.27 1.21 1.21 0 0 1 1.27-1.11c.23 0 22.62 1.36 41.64-19.94a1.19 1.19 0 1 1 1.78 1.58c-17.27 19.26-36.78 20.74-42.18 20.74ZM1761.93 569.66c-6.38-1.36-12 5-12.55 5.7a12.92 12.92 0 0 0 9.41 3.37c3.92-.36 8.46-3 8.28-5.37-.14-1.89-3.14-3.27-5.14-3.7ZM1748.12 583.77c-3.69-4.33-10.93-2.9-11.71-2.73a11.29 11.29 0 0 0 4.72 7.33c2.9 1.83 7.42 2.44 8.58.68.91-1.38-.44-3.93-1.59-5.28ZM1746 565.92c2.09 5.32-2.86 11-3.4 11.55-.87-.7-4-3.43-4.31-7.68-.2-3.43 1.51-7.67 3.7-7.83 1.7-.12 3.35 2.29 4.01 3.96ZM1729.62 574.4c3.61 4.44.61 11.31.27 12.05-1-.41-4.9-2-6.43-6-1.24-3.2-.9-7.77 1.14-8.58 1.59-.66 3.9 1.13 5.02 2.53Z"
        />
        <path
          className="clse4-1"
          d="M1724.08 595.16a1.17 1.17 0 0 1-.51-.11 1.19 1.19 0 0 1-.57-1.58c.28-.62 7.28-15.19 27.81-19.76a1.2 1.2 0 0 1 1.42.91 1.19 1.19 0 0 1-.91 1.42c-19.32 4.3-26.1 18.3-26.16 18.44a1.21 1.21 0 0 1-1.08.68ZM1680.15 646.64a3.6 3.6 0 0 1-3.39-4.73c3.08-9.07 7.75-14.79 13.89-17 6.89-2.47 12.77.5 18 3.12 4.53 2.3 8.44 4.28 12.82 3.15s6.45-4.59 9.35-10.13 6.23-11.86 14.1-14.24c7.21-2.17 13.24.48 18.55 2.82s8.52 3.59 12.07 2.06c4.24-1.82 7.31-7.13 9.1-15.77a3.57 3.57 0 1 1 7 1.45c-2.3 11.06-6.77 18.09-13.28 20.89s-12.53.22-17.77-2.09c-4.59-2-8.92-3.93-13.61-2.51-5 1.51-7.24 5.77-9.83 10.72-2.89 5.49-6.16 11.73-13.9 13.72-7 1.8-12.75-1.11-17.83-3.69s-8.51-4.13-12.32-2.77c-4 1.43-7.18 5.65-9.53 12.56a3.57 3.57 0 0 1-3.42 2.44Z"
        />
        <path
          className="clse4-3"
          d="M580.49 1725.25c19.13 25.71 42.66 81.15 12.53 112-18.29 18.73-51.23 23.11-74.46 11-46.82-24.37-28.55-102.38-27.64-106 3-12 11.46-46.16 34.64-51.37 25.12-5.71 49.29 26.79 54.93 34.37Z"
        />
        <path
          className="clse4-1"
          d="M584.14 1768.08c3.49 10-5.63 20.3-6.63 21.4-1.52-1.34-7.09-6.55-7.36-14.49-.21-6.39 3.05-14.24 7-14.45 3.05-.16 5.85 4.46 6.99 7.54ZM564.22 1793.25c7.73 5.06 6.9 17 6.79 18.31-1.76-.11-8.39-.76-12.79-6.1-3.54-4.31-5.46-11.47-2.85-13.7 2.04-1.76 6.43-.1 8.85 1.49ZM593.44 1793c-9-2.27-17.09 6.86-17.94 7.86 1.31 1.26 6.36 5.83 13.27 5.37 5.57-.37 12.07-4 11.87-7.56-.15-2.78-4.38-4.94-7.2-5.67ZM583.11 1821.15c-7.9-4.91-18.36 1.35-19.48 2 .87 1.6 4.29 7.49 11 9.15 5.41 1.34 12.71-.15 13.61-3.6.76-2.7-2.66-6.02-5.13-7.55Z"
        />
        <path
          className="clse4-1"
          d="M552.69 1835.3a1.19 1.19 0 0 1-.64-2.2c.22-.14 21.7-14.09 24.71-46.54a1.18 1.18 0 0 1 1.3-1.08 1.19 1.19 0 0 1 1.08 1.3c-3.13 33.67-25.59 48.19-25.82 48.33a1.11 1.11 0 0 1-.63.19ZM527.94 1708c-6.76 3.07-7.56 12.67-7.64 13.7 1.42.13 6.75.43 10.9-3.28 3.34-3 5.73-8.43 3.94-10.51-1.4-1.65-5.09-.91-7.2.09ZM524.83 1730.24c-6.3-1.47-12 4.74-12.56 5.42a12.79 12.79 0 0 0 9.27 3.52c3.9-.29 8.45-2.78 8.32-5.17-.1-1.88-3.06-3.31-5.03-3.77ZM510.82 1715.34c5.51 3.46 4.79 12 4.7 12.88-1.28-.06-6-.4-9.14-4.12-2.51-3-3.81-8-1.92-9.67 1.54-1.27 4.63-.18 6.36.91ZM501.57 1734.17c6.3 1.63 8.19 9.95 8.38 10.85-1.22.33-5.86 1.44-9.95-1.16-3.3-2.09-6.07-6.51-4.76-8.63 1.03-1.66 4.35-1.57 6.33-1.06Z"
        />
        <path
          className="clse4-1"
          d="M509.72 1757a1.19 1.19 0 0 1-1.17-1c-.15-.76-3.58-18.75 12.07-36.75a1.19 1.19 0 1 1 1.8 1.56c-14.89 17.12-11.57 34.54-11.53 34.71a1.2 1.2 0 0 1-.89 1.48ZM502.69 1834.05a3.58 3.58 0 0 1-3.41-2.49c-3.26-10.23-2.87-18.48 1.17-24.51 4.52-6.75 11.8-8 18.22-9.07 5.56-.94 10.8-1.83 14.17-6 3.6-4.42 2.77-9.78 1.82-16-1.07-7-2.29-14.87 3.19-22.19 5-6.72 12.23-8.35 18.59-9.78s10.45-2.53 12.77-6.5c2.74-4.69 2-11.78-2.31-21.06a3.57 3.57 0 1 1 6.49-3c5.31 11.53 6 20.83 2 27.65s-11.1 8.46-17.37 9.87c-5.65 1.28-11 2.48-14.44 7.09-3.68 4.92-2.83 10.44-1.85 16.83 1.06 6.88 2.27 14.68-3.33 21.57-5.07 6.23-12.22 7.44-18.52 8.51-5.73 1-10.67 1.8-13.48 6s-2.87 10.3-.3 18.36a3.57 3.57 0 0 1-2.31 4.49 3.49 3.49 0 0 1-1.1.23Z"
        />
        <path
          className="clse4-3"
          d="M255.4 1175.26c.09 28.16-12.21 79.63-49.6 85.7-22.7 3.68-48.28-10.41-58.38-31.08-20.37-41.67 33.26-87.27 35.82-89.39 8.35-6.92 32.19-26.65 51.29-18.23 20.72 9.12 20.84 44.74 20.87 53Z"
        />
        <path
          className="clse4-1"
          d="M235.61 1207.44c-2.75 8.9-14.57 11.42-15.85 11.67-.38-1.74-1.59-8.34 2.36-14.08 3.19-4.63 9.59-8.48 12.47-6.58 2.26 1.49 1.88 6.2 1.02 8.99ZM208.4 1214.83c2.83 7.61-4 15.64-4.76 16.49-1.19-1-5.53-4.91-5.85-11-.26-4.89 2.13-10.95 5.13-11.17 2.35-.15 4.6 3.3 5.48 5.68ZM229.17 1229.92c-5.18-6.31-15.65-4.07-16.77-3.82.26 1.58 1.45 7.45 6.57 10.73 4.13 2.65 10.62 3.47 12.34.86 1.35-2.05-.51-5.79-2.14-7.77ZM207.19 1244.41c-3-7.58-13.68-8.63-14.83-8.72-.23 1.58-.88 7.53 3 12.21 3.13 3.78 9.06 6.53 11.5 4.56 1.91-1.54 1.27-5.67.33-8.05Z"
        />
        <path
          className="clse4-1"
          d="M180.25 1238.92h-1.42a1.19 1.19 0 0 1 .18-2.38c.22 0 22.62 1.36 41.64-19.94a1.19 1.19 0 1 1 1.78 1.58c-17.27 19.31-36.78 20.74-42.18 20.74ZM227.26 1135.63c-6.38-1.36-12 5-12.55 5.7.94.83 4.55 3.83 9.41 3.37 3.92-.36 8.46-3 8.28-5.37-.14-1.89-3.15-3.27-5.14-3.7ZM213.44 1149.74c-3.68-4.33-10.92-2.89-11.7-2.73a11.25 11.25 0 0 0 4.72 7.33c2.9 1.83 7.42 2.45 8.58.68.9-1.38-.44-3.93-1.6-5.28ZM211.32 1131.89c2.09 5.32-2.86 10.95-3.4 11.55-.87-.7-4-3.43-4.31-7.68-.21-3.42 1.51-7.67 3.69-7.83 1.7-.12 3.36 2.29 4.02 3.96ZM195 1140.37c3.61 4.44.6 11.31.27 12.05-1-.41-4.9-2-6.44-6-1.23-3.2-.89-7.77 1.14-8.58 1.55-.66 3.85 1.16 5.03 2.53Z"
        />
        <path
          className="clse4-1"
          d="M189.4 1161.13a1.1 1.1 0 0 1-.5-.11 1.19 1.19 0 0 1-.58-1.58c.29-.62 7.29-15.19 27.81-19.76a1.23 1.23 0 0 1 1.43.91 1.2 1.2 0 0 1-.91 1.42c-19.33 4.3-26.1 18.3-26.17 18.44a1.19 1.19 0 0 1-1.08.68ZM145.47 1212.61a3.51 3.51 0 0 1-1.14-.2 3.57 3.57 0 0 1-2.24-4.53c3.08-9.07 7.75-14.79 13.88-17 6.9-2.47 12.78.5 18 3.12 4.53 2.3 8.45 4.28 12.83 3.15s6.44-4.59 9.35-10.13 6.23-11.86 14.09-14.23c7.22-2.18 13.24.47 18.55 2.81s8.52 3.59 12.07 2.06c4.25-1.82 7.31-7.13 9.11-15.77a3.57 3.57 0 1 1 7 1.45c-2.3 11.06-6.77 18.09-13.28 20.89s-12.53.22-17.78-2.09c-4.58-2-8.91-3.92-13.6-2.51-5 1.51-7.24 5.77-9.83 10.72-2.89 5.5-6.16 11.73-13.9 13.72-7 1.8-12.75-1.11-17.84-3.69s-8.5-4.13-12.31-2.77c-4 1.43-7.19 5.65-9.53 12.56a3.59 3.59 0 0 1-3.43 2.44Z"
        />
        <path
          className="clse4-3"
          d="M1478.28 230.27c18.79 21 43.84 67.58 20 97-14.51 17.86-43 24.34-64.27 15.63-42.93-17.57-33.21-87.29-32.71-90.58 1.64-10.72 6.32-41.31 26.18-47.73 21.52-7 45.25 19.5 50.8 25.68Z"
        />
        <path
          className="clse4-1"
          d="M1484.9 267.45c3.87 8.47-3.29 18.22-4.07 19.26-1.44-1-6.74-5.17-7.61-12.09-.7-5.57 1.53-12.7 4.94-13.2 2.68-.42 5.53 3.38 6.74 6.03ZM1469.5 291.07c7.17 3.81 7.4 14.34 7.41 15.48-1.55 0-7.4 0-11.68-4.31-3.45-3.49-5.7-9.6-3.6-11.76 1.65-1.69 5.62-.6 7.87.59ZM1495.05 288.52c-8.07-1.27-14.4 7.37-15.07 8.31 1.24 1 6 4.59 12 3.64 4.85-.77 10.24-4.47 9.79-7.57-.32-2.43-4.2-3.98-6.72-4.38ZM1488.27 314c-7.31-3.66-16 2.65-16.88 3.34.88 1.33 4.36 6.21 10.37 7.12 4.85.74 11.11-1.15 11.62-4.24.4-2.45-2.83-5.11-5.11-6.22Z"
        />
        <path
          className="clse4-1"
          d="M1462.69 328.94a1.19 1.19 0 0 1-.73-2.14c.18-.13 17.8-14 17.83-42.59A1.19 1.19 0 0 1 1481 283a1.19 1.19 0 0 1 1.19 1.19c0 29.79-18 43.9-18.76 44.48a1.15 1.15 0 0 1-.74.27ZM1430.9 219.39c-5.66 3.22-5.6 11.69-5.58 12.6 1.25 0 6-.17 9.27-3.75 2.69-2.88 4.35-7.83 2.61-9.51-1.36-1.32-4.52-.35-6.3.66ZM1430 239.11c-5.63-.78-10.08 5.1-10.55 5.75a11.24 11.24 0 0 0 8.39 2.33c3.39-.56 7.17-3.11 6.86-5.19-.27-1.64-2.97-2.65-4.7-2.89ZM1416.51 227.19c5.1 2.59 5.15 10.08 5.15 10.89-1.12.06-5.31.14-8.33-2.87-2.43-2.42-4-6.73-2.45-8.3 1.2-1.24 4.03-.53 5.63.28ZM1409.93 244.41c5.65.92 8 8.05 8.21 8.82-1 .39-5 1.74-8.8-.21-3.06-1.57-5.84-5.21-4.86-7.17.77-1.54 3.68-1.72 5.45-1.44Z"
        />
        <path
          className="clse4-1"
          d="M1418.8 263.91a1.21 1.21 0 0 1-1.14-.85c-.19-.65-4.66-16.19 7.63-33.25a1.19 1.19 0 0 1 1.94 1.39c-11.58 16.07-7.33 31-7.28 31.18a1.2 1.2 0 0 1-.8 1.48 1.41 1.41 0 0 1-.35.05ZM1418.65 332.17a3.56 3.56 0 0 1-3.29-2.19c-3.74-8.82-4-16.2-.93-21.92 3.5-6.43 9.87-8.12 15.48-9.61 4.91-1.3 9.15-2.43 11.67-6.18s1.76-7.72.25-13.78-3.24-13 1.06-20c3.94-6.42 10.2-8.45 15.72-10.24s8.75-3 10.39-6.48c2-4.19.71-10.19-3.7-17.84a3.58 3.58 0 0 1 6.2-3.57c5.64 9.79 7 18 4 24.44s-9.21 8.49-14.66 10.25c-4.77 1.55-9.27 3-11.83 7.18-2.73 4.45-1.56 9.12-.21 14.54 1.5 6 3.2 12.86-1.25 19.49-4 6-10.27 7.65-15.77 9.11s-9.11 2.57-11 6.12c-2 3.71-1.6 9 1.24 15.72a3.57 3.57 0 0 1-1.9 4.68 3.61 3.61 0 0 1-1.47.28Z"
        />
        <path
          className="clse4-3"
          d="M573.88 222.81C583 257.38 584.33 324.57 540.33 344c-26.73 11.79-62.66 2.64-81.69-19.53-38.36-44.69 13-117.87 15.44-121.3 8.06-11.17 31-43 57.21-38.81 28.37 4.57 39.9 48.26 42.59 58.45Z"
        />
        <path
          className="clse4-1"
          d="M559.85 268.68c-.53 11.81-14.25 18.69-15.74 19.41-1-2-4.63-9.74-1.61-18.06 2.44-6.71 9.08-13.49 13.22-12.07 3.28 1.11 4.28 7.04 4.13 10.72ZM528.77 286.46c5.91 8.45.08 20.5-.57 21.79-1.78-.85-8.37-4.27-10.71-11.63-1.88-5.94-.89-14.15 2.73-15.37 2.84-.96 6.7 2.57 8.55 5.21ZM559.13 298.36c-8.39-6.1-20.54 0-21.84.68.83 1.85 4.16 8.68 11.51 11.08 5.92 1.93 14.16.87 15.44-2.9 1-2.95-2.49-6.95-5.11-8.86ZM536.74 323.2c-6.14-8.36-19.57-6.23-21-6 .23 2 1.33 9.54 7.6 14 5.06 3.64 13.23 5.13 15.59 1.93 1.84-2.44-.27-7.31-2.19-9.93Z"
        />
        <path
          className="clse4-1"
          d="M499.86 325.17a1.19 1.19 0 0 1-.22-2.36c.28-.05 28.39-5.58 45-38a1.2 1.2 0 0 1 2.13 1.09c-17.2 33.51-46.43 39.2-46.72 39.25a.75.75 0 0 1-.19.02ZM526.62 183.1c-8.26.37-13.08 10-13.59 11 1.42.72 6.81 3.24 12.64 1.13 4.7-1.7 9.45-6.34 8.46-9.25-.78-2.25-4.91-2.98-7.51-2.88ZM514.16 204.85c-5.91-4.13-14.35-.06-15.25.4.59 1.24 3 5.86 8.14 7.5 4.15 1.32 9.9.63 10.76-1.91.67-1.98-1.81-4.69-3.65-5.99ZM505.84 183.6c4.27 5.87 0 14.38-.48 15.29-1.29-.58-6.08-2.92-7.75-8.06-1.35-4.15-.6-9.92 2-10.81 2.1-.7 4.9 1.74 6.23 3.58ZM488.44 199.26c5.85 4.3 4.36 13.7 4.18 14.71-1.41-.16-6.67-.93-9.83-5.33-2.54-3.54-3.58-9.26-1.34-10.91 1.75-1.29 5.16.18 6.99 1.53Z"
        />
        <path
          className="clse4-1"
          d="M487.88 226.27a.75.75 0 0 1-.21 0 1.19 1.19 0 0 1-1-1.38c.15-.85 4.07-20.84 27.69-32.94a1.19 1.19 0 0 1 1.09 2.12c-22.59 11.57-26.4 31-26.44 31.25a1.18 1.18 0 0 1-1.13.95ZM449.59 303h-.26a3.59 3.59 0 0 1-3.31-3.83c.87-11.83 4.64-20.1 11.22-24.59 7.33-5 15.29-3.28 22.32-1.76 6.22 1.35 12.09 2.63 17.44-.33 5.72-3.18 7.11-9.15 8.72-16.06 1.76-7.58 3.77-16.18 12.33-21.4 7.87-4.79 15.93-3.49 23-2.35 6.36 1 11.84 1.91 16.24-1.51 4.9-3.8 7.09-11.57 6.52-23.1a3.57 3.57 0 1 1 7.14-.36c.69 14-2.42 23.79-9.27 29.11s-14.78 4-21.76 2.92c-6.47-1-12.57-2-18.19 1.4-6 3.65-7.43 9.8-9.09 16.91-1.74 7.49-3.72 16-12.22 20.69-7.69 4.27-15.52 2.57-22.42 1.07-6.43-1.4-12-2.6-16.77.67s-7.42 9.67-8.12 19.21a3.57 3.57 0 0 1-3.52 3.31ZM188.2 523.25c2.17 44.48 3.4 89 4.3 133.44.53 22.24.73 44.48 1.09 66.72l.56 66.72v66.73l-.15 33.36-.1 16.68-.21 16.69c-.5 44.48-1.34 89-3.12 133.46-2.18-44.47-3.42-88.95-4.32-133.43l-.35-16.68-.25-16.68-.49-33.36-.55-66.73v-66.72c.16-22.24.16-44.49.5-66.73.48-44.49 1.31-88.97 3.09-133.47ZM1566.78 1760.05c-44.48 2-89 3-133.45 3.7-22.24.44-44.48.54-66.72.8l-66.73.26-66.72-.25-33.37-.34-16.68-.17-16.68-.28c-44.48-.7-89-1.74-133.45-3.72 44.48-2 89-3 133.45-3.72l16.68-.28 16.68-.18 33.37-.33 66.72-.25 66.73.26c22.24.26 44.48.35 66.72.79 44.49.66 88.97 1.74 133.45 3.71Z"
        />
        {children}
      </g>
    </svg>
  );
}
